import { Link, useParams } from "react-router-dom";
import { Check } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import { PORTAL_T } from "@/lib/portalSubmitI18n";

export default function PortalSuccess() {
  const { theme, dir, lang } = useI18n();
  const { num } = useParams();
  const T = PORTAL_T[lang];

  const css = {
    page: {
      minHeight: "calc(100vh - 120px)",
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      padding: "60px 24px", textAlign: "center",
      fontFamily: "'Tajawal','Segoe UI',sans-serif", color: theme.text,
    },
    badge: {
      width: 88, height: 88, borderRadius: "50%",
      background: "rgba(34,197,94,0.15)", border: "2px solid #16a34a",
      display: "flex", alignItems: "center", justifyContent: "center",
      color: "#16a34a", fontSize: 40, marginBottom: 22,
    },
    title: { fontSize: 22, fontWeight: 900, color: theme.gold, margin: 0 },
    no: {
      fontFamily: "monospace", letterSpacing: 2,
      fontSize: 28, fontWeight: 900, color: theme.text, margin: "16px 0",
      padding: "12px 24px", background: theme.surfaceCard,
      border: `1px solid ${theme.borderAccent}`, borderRadius: 12,
    },
    body: { fontSize: 14, color: theme.textSoft, maxWidth: 520, lineHeight: 1.8 },
    btn: {
      marginTop: 28, padding: "14px 28px",
      background: theme.goldGradient, color: theme.name === "dark" ? "#0a0a0a" : "#fff",
      border: "none", borderRadius: 12, fontWeight: 800, fontSize: 14,
      textDecoration: "none", display: "inline-block",
    },
  };

  return (
    <div dir={dir} style={css.page} data-testid="portal-success">
      <div style={css.badge}><Check size={44} strokeWidth={3} /></div>
      <h1 style={css.title}>{T.success_title}</h1>
      <div style={css.no} data-testid="success-app-number">{num}</div>
      <p style={css.body}>{T.success_body("", num)}</p>
      <Link to={`../track/${num}`} style={css.btn} data-testid="success-track-btn">
        {T.success_track}
      </Link>
    </div>
  );
}
